import { useEffect, useState } from 'react'
import { Modal, Checkbox, Button, Space } from 'antd'

export const EXPORTABLE_COLUMNS: { key: string; label: string }[] = [
  { key: 'id', label: '数据项ID' },
  { key: 'name', label: '数据名称' },
  { key: 'source', label: '来源' },
  { key: 'type', label: '类型' },
  { key: 'documentStatus', label: '单据状态' },
  { key: 'onChain', label: '上链状态' },
  { key: 'contractNo', label: '合同号' },
  { key: 'contractType', label: '合同类型' },
  { key: 'customer', label: '客户' },
  { key: 'settlementOrg', label: '结算组织' },
  { key: 'productName', label: '商品名称' },
  { key: 'priceTaxTotal', label: '价税合计' },
  { key: 'receiptAmount', label: '收款金额' },
  { key: 'partialReceipt', label: '部分收款' },
  { key: 'unreceivedAmount', label: '应收账款资产' }, // 暂时隐藏
  { key: 'invoicedAmount', label: '已开票额' },
  { key: 'contractCreatedDate', label: '合同创建日期' },
  { key: 'contractReceiptDate', label: '合同收款日期' },
  { key: 'value', label: '价值' },
  { key: 'status', label: '状态' },
  { key: 'contractAttachment', label: '合同附件' },
  { key: 'orderAttachment', label: '订单附件' },
  { key: 'receiptAttachment', label: '收款附件' },
  { key: 'logisticsAttachment', label: '物流附件' },
  { key: 'invoiceAttachment', label: '发票附件' },
  { key: 'createdTime', label: '创建时间' },
]

const DEFAULT_KEYS = EXPORTABLE_COLUMNS.filter((c) => c.key !== 'value').map((c) => c.key)

type Props = {
  open: boolean
  exporting?: boolean
  onCancel: () => void
  onConfirm: (columns: string[]) => void
}

export default function ExportFieldModal({ open, exporting, onCancel, onConfirm }: Props) {
  const [checked, setChecked] = useState<string[]>(DEFAULT_KEYS)

  useEffect(() => {
    if (open) setChecked(DEFAULT_KEYS)
  }, [open])

  const allChecked = checked.length === EXPORTABLE_COLUMNS.length
  const indeterminate = checked.length > 0 && !allChecked

  return (
    <Modal
      title="选择导出字段"
      open={open}
      onCancel={onCancel}
      width={560}
      footer={
        <Space>
          <Button onClick={onCancel}>取消</Button>
          <Button
            type="primary"
            loading={exporting}
            disabled={!checked.length}
            onClick={() => onConfirm(checked)}
          >
            确认导出
          </Button>
        </Space>
      }
    >
      <div className="mb-3">
        <Checkbox
          indeterminate={indeterminate}
          checked={allChecked}
          onChange={(e) => setChecked(e.target.checked ? DEFAULT_KEYS : [])}
        >
          全选
        </Checkbox>
      </div>
      <Checkbox.Group
        className="w-full"
        value={checked}
        onChange={(vals) => setChecked(vals as string[])}
      >
        <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
          {EXPORTABLE_COLUMNS.map((c) => (
            <Checkbox key={c.key} value={c.key}>
              {c.label}
            </Checkbox>
          ))}
        </div>
      </Checkbox.Group>
    </Modal>
  )
}
